import { DefaultTemplateContext } from '@leshen/gatsby-theme-sylex/src/types/types'
import type { WrapPageElementBrowserArgs } from 'gatsby'
import React from 'react'
import Wrapper from './src/components/Wrapper'

type WrapPageElementProps = WrapPageElementBrowserArgs<Record<string, unknown>, DefaultTemplateContext>

export const wrapPageElement = ({ element, props }: WrapPageElementProps) => {
  const theme = props.pageContext.customTheme
  return theme ? <Wrapper theme={theme}>{element}</Wrapper> : element
}
